<template>
  <el-container class="carPassingRecord">
    <!-- 过车记录 -->
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <h-unfold @refreshTableEmit="refreshTable">
          <template #type>
            <h-selectcode
              @change="changeSelect"
              v-model="tableParams.cameraInOutType"
              placeholder="进/出"
              type="camera_inout_type"
              :style="{ width: '300px' }"
            >
            </h-selectcode>
          </template>
          <el-form-item label="姓名" prop="prisonName">
            <el-autocomplete
              v-model="tableParams.name"
              :fetch-suggestions="searchAsync"
              @select="handleSelect"
              placeholder=""
              clearable
            >
              <template #suffix>
                <div @click="getPoint" style="cursor: pointer">
                  <el-icon>
                    <Search></Search>
                  </el-icon>
                </div>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item>
            <HCarPlateNoSelect
              v-model:plateColor="tableParams.plateColor"
              v-model:plateNo="tableParams.plateNo"
              ref="plateNoRef"
            />
          </el-form-item>
          <el-form-item
            label="进/出"
            style="width: 180px"
            prop="cameraInOutType"
          >
            <h-selectcode
              @change="changeSelect"
              v-model="tableParams.cameraInOutType"
              placeholder="进/出"
              type="camera_inout_type"
              :style="{ width: '300px' }"
            >
            </h-selectcode>
          </el-form-item>
          <el-form-item label="区域" prop="sszh">
            <el-cascader
              :options="treeData"
              :show-all-levels="false"
              :props="props"
              v-model="sszh"
              @change="cascaderChange"
              placeholder="区域"
            >
            </el-cascader>
          </el-form-item>

          <el-form-item label="门禁点" prop="deviceIds">
            <el-select
              v-model="tableParams.deviceIds"
              clearable
              multiple
              collapse-tags
              collapse-tags-tooltip
              placeholder="门禁点"
            >
              <el-option
                :label="item.cameraName"
                :value="item.otherId"
                v-for="item in mjdList"
                :key="item.otherId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通行时间">
            <h-date-timerange
              v-model:end="tableParams.endTime"
              v-model:start="tableParams.beginTime"
              :clearable="false"
            >
            </h-date-timerange>
          </el-form-item>

          <el-form-item>
            <h-button type="primary" @click="refreshTable">查询</h-button>
            <h-button @click="resetForm(formRef)">重置</h-button>
          </el-form-item>
        </h-unfold>
        <el-row>
          <el-col>
            <h-button type="primary" @click="exporting">导出</h-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="container" v-loading="loading">
        <el-empty class="h-card-empty" v-if="tableData.length == 0"></el-empty>
        <div class="centerBox" v-else>
          <div
            class="centerList"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <div class="centerImg" @click="detailClick(item)">
              <img
                v-if="item.vehicleUrlHttp"
                :src="item.base64Url || item.vehicleUrlHttp"
              />
              <img v-else src="~@/assets/images/moren.png" />
            </div>
            <div class="centerTitle">
              <h-car-plate :type="item.plateColor" :colorData="colorDict" title="">{{
                item.plateNo
              }}</h-car-plate>
              <span>门禁点：{{ item.deviceName }}</span>
              <span
                >通行时间： <span>{{ item.passTimeDesc }}</span></span
              >
            </div>
            <div class="inOut">
              {{ tableInOutTypeDict[cameraDeviceObj[item.deviceId]] }}
            </div>
          </div>
        </div>
        <div class="pagination">
          <!-- 分页 -->
          <el-pagination
            v-model:currentPage="tableParams.pageNum"
            v-model:page-size="tableParams.pageSize"
            :page-size="[20, 50, 100, 200]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationTotal"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </el-card>
    <carDetailDialog
      v-if="carDetailVisible"
      v-model:visible="carDetailVisible"
      :itemInfo="carDetailItem"
      :tableParams="tableParams"
    ></carDetailDialog>
  </el-container>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  watchEffect,
  nextTick
} from "vue";

import util from "@util/js";
import moment from "moment";
import { queryTreeAreaVideo, queryTreeAreaVideoAll } from "@/api/videoControl/videoApi.js";
import {
  recordWithTotal,
  carRecord,
  carRecordExport
} from "@/api/smartApplication/smartApplicationApi.js";
import { getMenutree } from "@/api/system/region.js";
import { carlist } from "@/api/realHouse/realHouse.js";
import { url2ToBase } from "@/api/smartApplication/personSearchApi.js";
import { infolistAll } from "@/api/realPopulation/realPopulation";
import { formatDateHMS } from "@/utils/index.js";
import { ElMessage } from "element-plus";
import { getDict } from "@/api/constant";
// import _ from "lodash";
export default defineComponent({
  name: "carPassingRecord",
  props: {},
  setup(props) {
    const state = reactive({
      loading: false,
      props: { multiple: false, label: "name", value: "id", checkStrictly: true },
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column"
      },
      dataSource: [],
      userFormData: {},

      tableParams: {
        plateNo: "渝",
        plateColor: "5",
        name: "",
        prisonName: "",
        cameraInOutType: "1",
        deviceIds: [],
        endTime: formatDateHMS(new Date()),
        beginTime: formatDateHMS(new Date().getTime() - 24 * 3600 * 1000 * 7),
        regionId: 1,
        isPage: true,
        pageNum: 1,
        pageSize: 20
      },
      tableData: [],
      sszh: [], // 所属组织
      treeData: [],
      mjdList: [],
      cameraInOutType: {},

      tableData: [],
      paginationTotal: 0,
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      columns: [
        { type: "selection" },
        {
          label: "车辆图片",
          slot: "imageUrl" // sex
        },
        {
          label: "车牌号",
          prop: "plateNo"
        },
        {
          label: "姓名",
          prop: "prisonName"
        },
        {
          label: "监控点",
          prop: "deviceName" // nation
        },
        {
          label: "进/出",
          slot: "default"
        },
        {
          label: "通行时间",
          prop: "passTimeDesc"
        }
      ],
      cameraDeviceArr: [],

      tableInOutTypeDict: {
        1: "进",
        2: "出",
        3: "进/出"
      }, // 摄像机类型
      cameraDeviceObj: {},
      carDetailVisible: false,
      carDetailItem: {},
      base64Str: "data:image/png;base64,",
      timeOut: null,
      outNetwork: window.outNetwork,
      colorDict: []
    });
    const refData = toRefs(state);
    const tableRef = ref(null);
    const formRef = ref(null);

    // 点击查询按钮
    const refreshTable = async () => {
      if (state.tableParams.deviceIds.length == 0) {
        await cascaderChange();
        state.tableParams.deviceIds = state.cameraDeviceArr;
      }
      if (state.cameraDeviceArr.length == 0) {
        ElMessage.warning("无当前进出状态设备，请重新选择");
        return;
      }
      state.tableData = [];
      state.loading = true;
      carRecord(state.tableParams).then(
        (res) => {
          state.tableData = res.page.list;
          state.paginationTotal = res.page.totalCount;
          state.loading = false;

          state.tableData.forEach(async (element) => {
            if (outNetwork && element.vehicleUrlHttp) {
              const params = {
                paths: [element.vehicleUrlHttp]
              };
              const res = await url2ToBase(params);
              element.base64Url = state.base64Str + res.data[0];
              element.changeUrl = true; // url需要准换标识
            }
          });
        },
        () => {
          state.loading = false;
        }
      );

      // getCarRecord();
    };

    // 获取数据字典
    const queryMenuType = async () => {
      const resCarColor = await getDict("car_card_color");
      nextTick(() => {
        state.colorDict = resCarColor.dict;
      });
    };
    queryMenuType();
    // 重置表单
    const resetForm = (formRef) => {
      if (!formRef) return;
      formRef.resetFields();
      state.tableParams.plateNo = "";
      state.tableParams.plateColor = "";
      state.tableParams.name = "";
    };
    // 详情弹窗
    const detailClick = (item) => {
      state.carDetailItem = item;
      state.carDetailVisible = true;
    };
    const infolistAllAxios = async () => {
      // const res = await infolistAll(state.params);
      // const options = { pid: "parentId", id: "regionId", rootPid: res.top };
      // const treeData = util.arrayToTree(res.data, options);
      // state.treeData = treeData;
      const result = await getMenutree();
      if (result.data) {
        const filterCommunity = (list) => {
          return list.filter((item) => {
            if (item.children.length > 0 && Number(item.type) < 2) {
              filterCommunity(item.children);
              return item;
            }
            return item.type != "-1" || Number(item.type) < 4;
          });
        };
        state.treeData = filterCommunity([result.data])[0].children;
      }
    };
    infolistAllAxios();
    const cascaderChange = async (val = 0) => {
      console.log(state.sszh);

      state.tableParams.deviceIds = [];
      const from = {
        areaId: state.sszh.length > 0 ? state.sszh[state.sszh.length - 1] : '',
        cameraInOutType: state.tableParams.cameraInOutType,
        inOutTypeFlag: "1", // 此参数查所有绑定进出设备摄像头
        subType: 8
      };
      // from.areaId = val[val.length - 1];
      const ress = await queryTreeAreaVideo(from);
      state.mjdList = ress.cameraBaseDtls;
      ress.cameraBaseDtls.map((item, e) => {
        state.cameraDeviceObj[item.deviceId] = item.cameraInOutType;
      });
      state.cameraDeviceArr = ress.cameraBaseDtls.map((item) => {
        return item.deviceId;
      });
    };
    cascaderChange();
    // 改变设备状态更新区域数据
    const changeSelect = (val) => {
      state.tableParams.cameraInOutType = val;
      state.cameraDeviceArr = [];
      state.sszh = [];
      state.tableParams.deviceIds = [];
      refreshTable();
    };
    // 翻页
    const handleCurrentChange = (val) => {
      state.tableParams.pageNum = val;
      refreshTable();
    };
    // 翻页
    const handleSizeChange = (val) => {
      state.tableParams.pageSize = val;
      refreshTable();
    };
    // 获取结构树
    const searchAsync = async (queyString, cb) => {
      state.tableParams.plateNo = "";
      state.tableParams.plateColor = "";
      const form = {
        prisonName: state.tableParams.name,
        isPage: false
      };
      clearTimeout(data.timeOut);
      state.timeOut = setTimeout(async () => {
        const res = await carlist(form);
        if (res.code == 0) {
          res.page.list.forEach((element) => {
            element.value =
              element.prisonInfo.name +
              "   " +
              element.carProvinceDict +
              element.carNumber;
          });
          cb(res.page.list);
        }
      }, 1500);
    };
    // 点击结构树
    const handleSelect = async (item) => {
      state.tableParams.name = item.prisonInfo.name;
      state.tableParams.plateNo = item.carProvinceDict + item.carNumber;
      state.tableParams.plateColor = item.carCardColor;
    };
    // 列表导出
    const exporting = async () => {
      const params = { ...state.tableParams };
      ElMessage.success("数据量较大请等待！");
      carRecordExport(params).then((res) => {
        util.exporting(res);
      });
    };
    return {
      ...refData,
      moment,
      refreshTable,
      changeSelect,
      resetForm,
      carRecord,
      tableRef,
      formRef,
      cascaderChange,
      detailClick,
      handleCurrentChange,
      searchAsync,
      handleSelect,
      handleSizeChange,
      exporting
    };
  }
});
</script>
<style lang="scss" scoped>
.carPassingRecord {
  height: 100%;
  width: 100%;
  .tabs-card {
    flex: 1;
    justify-content: space-between;
    .container {
      display: flex;
      flex-direction: column;
      height: 100%;
      margin-top: 15px;
      overflow: auto;

      .pagination {
        margin-top: 12px;
      }
      .centerBox {
        width: 100%;
        height: calc(100% - 135px);
        flex: 1;
        display: grid;
        grid-template-columns: repeat(auto-fill, 316px);
        grid-template-rows: repeat(auto-fill, 214px);
        grid-gap: 11px 24px;
        justify-content: space-around;
        overflow: auto;

        .centerList {
          position: relative;
          width: 300px;
          height: 210px;
          border-radius: 10px;
          margin: 10px;
          padding: 16px;
          box-shadow: 0 5px 15px 0 #b1abab;
          cursor: pointer;
          .centerTitle {
            height: 90px;
            text-align: center;
            @include flex-col-c-s;
            .HCarPlate{
              margin: 0 auto;
            }
          }
          .centerImg {
            height: 60%;
            img {
              width: 100%;
              height: 100%;
              border-radius: 4px 4px 0 0;
            }
          }
          .inOut {
            position: absolute;
            top: 0px;
            right: 0px;
            color: red;
          }
        }
      }
    }
  }
}
</style>
